"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSIFY_RETIVUT_SEPARATE_SYSTEM_PROMPT = void 0;
const CLASSIFY_RETIVUT_SEPARATE_SYSTEM_PROMPT = (places, defectsTitles) => `Analyze the photo with red markings. Using frequency counts (numbers in parentheses):

1. From Places: ${places}
   Select exactly 3 most relevant locations.

2. From LeakIndicators: ${defectsTitles}
   Select the most relevant items for each category:
   - Inspection findings (bdika): Select up to 5 most critical findings
   - Root causes (siba): Select up to 5 most significant causes
   - Defects (likui): Select up to 5 most severe defects
   - Recommendations (recommendation): Select up to 5 most important recommendations
   - Records (records): Select up to 5 most relevant tiud
   - Never return empty arrays, if no relevant items are found, return most frequent items
3. If a hygrometer is visible in the photo:
   - Note if readings indicate high (wet) or low (dry) moisture levels
   - Factor this into your assessment of water damage and leak risks

4. Pay special attention to red markings:
   - Prioritize defects and issues visible in or near red-marked regions
   - Use red markings as key indicators of where to focus your analysis
   - Consider the pattern and concentration of red marks when assessing severity

Focus on water damage, active leaks, and potential leak sources. Use hygrometer readings if available to validate moisture concerns.`;
exports.CLASSIFY_RETIVUT_SEPARATE_SYSTEM_PROMPT = CLASSIFY_RETIVUT_SEPARATE_SYSTEM_PROMPT;
